/* eslint-disable no-unused-vars */
"use client";
import * as React from "react";
import { ThemeProvider } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { SxProps, Theme } from "@mui/material/styles";
import { EnhancedTableProps, EnhancedTableToolbarProps, HeadCell } from "../../Objects/interfaces/TableTypes";
import { customTheme } from "../../Theme/theme";

function EnhancedTableHead(props: EnhancedTableProps) {
  const { headCells } = props;

  return (
    <TableHead>
      <TableRow>
        {headCells
          .filter((headCell) => !headCell.disable)
          .map((headCell, index) => (
            <TableCell
              sx={{ paddingBottom: 2, paddingTop: 2 }}
              key={index}
              align={headCell.align ?? "left"}
            >
              <TableSortLabel>{headCell.label}</TableSortLabel>
            </TableCell>
          ))}
      </TableRow>
    </TableHead>
  );
}
function EnhancedTableToolbar(props: EnhancedTableToolbarProps) {
  const { title, child } = props;
  return (
    <Toolbar
      sx={[
        {
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
        },
      ]}
    >
      <Typography
        sx={{ flex: "1 1 100%" }}
        variant="h6"
        id="tableTitle"
        component="div"
      >
        {title}
      </Typography>
      {child}
    </Toolbar>
  );
}
interface Props {
  Children: React.ReactNode;
  headCells: HeadCell[];
  page: number;
  rowsPerPage: number;
  count: number;
  handleChangePage: (event: unknown, newPage: number) => void;
  handleChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => void;
  title?: string;
  child?: React.ReactNode;
  hidePagination?: boolean;
  size?: "small" | "medium";
  stickyHeader?: boolean;
  paperSx?: SxProps<Theme>;
}

export default function TableLayout({
  Children,
  headCells,
  page,
  handleChangePage,
  handleChangeRowsPerPage,
  rowsPerPage,
  count,
  title,
  child,
  hidePagination = false,
  size = "medium",
  stickyHeader = false,
  paperSx,
}: Props) {
  return (
    <ThemeProvider theme={customTheme}>
      <Box sx={{ width: "100%" }}>
        <Paper sx={{ width: "100%", mb: 2, borderRadius: 2, overflow: "hidden", ...paperSx }}>
          {title || child ? (
            <EnhancedTableToolbar title={title} child={child} />
          ) : null}
          <TableContainer>
            <Table stickyHeader={stickyHeader} size={size} sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
              <EnhancedTableHead headCells={headCells} />
              <TableBody>{Children}</TableBody>
            </Table>
          </TableContainer>
          {!hidePagination ? (
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={count}
              rowsPerPage={rowsPerPage}
              page={page - 1}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          ) : null}
        </Paper>
      </Box>
    </ThemeProvider>
  );
}
